// extracted by mini-css-extract-plugin
export default {"field_label":"tag-select_field_label__6ExBN","tag":"tag-select_tag__MntVJ","tags_wrapper":"tag-select_tags_wrapper__TUiVS","active_tag":"tag-select_active_tag__xRqUA"};